import CASL from '@/utils/constants/casl'

export default {
  path: 'warranty-packet',
  children: [
    {
      path: '',
      name: 'warranty-packet.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.GARANSI
      },
      component: () => import('./list/WarrantyPackageListPage.vue')
    },
    {
      path: 'add',
      name: 'warranty-packet.add',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.GARANSI
      },
      component: () => import('./form/WarrantyPackageFormPage.vue')
    },
    {
      path: ':uid',
      name: 'warranty-packet.edit',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.GARANSI
      },
      component: () => import('./form/WarrantyPackageFormPage.vue')
    }
  ]
}
